function formatCurrency(value: number, unitRate: string, locale: string, currency: string): string {
  const fractionDigits = unitRate === 'HOURLY' ? 2 : 0;

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency,
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  }).format(value);
}

export function formatSalary({
  locale,
  currency,
  salary: { minRate, maxRate, unitRate },
}: {
  locale: string;
  currency: string;
  salary: { minRate: number | null; maxRate: number | null; unitRate: string };
}): string {
  return [
    minRate && formatCurrency(minRate, unitRate, locale, currency),
    maxRate && formatCurrency(maxRate, unitRate, locale, currency),
  ]
    .filter(Boolean)
    .join(' - ');
}
